var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIdea = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.7 47.8C176.8 47.8 205.4 76.3 205.4 111.5C205.4 129.9 197.5 146.9 182 162C181.3 162.7 180.8 163.5 180.5 164.3L180.3 165.2L170.4 208.3C168.4 216.8 161.2 223 152.7 223.5H151.2H132.6C123.9 223.5 116.3 217.8 113.7 209.7L113.4 208.2L103.5 165.1C103.3 163.8 102.6 162.8 101.6 161.8C86.8 147.4 78.9 131.4 78.2 114V111.3V109.2C79.2 75.2 107.2 47.8 141.7 47.8ZM160.3 192.8H123.2L126.1 205.3C126.7 208 128.9 210 131.6 210.3L132.5 210.4H151.1C153.9 210.4 156.3 208.7 157.3 206.2L157.5 205.4L160.3 192.8ZM141.7 60.9C114.5 60.9 92.2 82.4 91.2 109.5V111.5L91.3 113.9C92 127.6 98.3 140.4 110.7 152.5C113 154.7 114.8 157.6 115.7 160.6L116.2 162.1L120.2 179.4H163.4L167.5 162.1C168.2 159 169.7 156 171.8 153.6L173 152.4C185.3 140.3 191.7 127.5 192.3 113.8L192.4 111.4V109.4C191.3 82.6 169 60.9 141.7 60.9Z",
    fill: "#212121"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdea, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/idea.83641508.svg";
export { ForwardRef as ReactComponent };